/**
 * Patient portal profile page.
 * Displays and allows editing of patient profile information.
 */
export function PortalProfile() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Profile</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Manage your personal information and settings
        </p>
      </div>

      {/* Placeholder content */}
      <div className="rounded-lg border-2 border-dashed border-gray-300 bg-white p-12 text-center dark:border-gray-700 dark:bg-gray-800">
        <div className="mx-auto max-w-md">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            Profile Coming Soon
          </h3>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Your profile information and settings will appear here.
          </p>
        </div>
      </div>
    </div>
  );
}
